module.exports = __webpack_public_path__ + "img/no_preservatives.ccc7744c.png";